import { Button, Theme, Tooltip, Typography } from '@mui/material';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import { FilterTypeToFilter } from '../../common/filters-utils/filters-utils';
import {
  getCategoryById,
  isRangeFilter,
  resolveFilterName,
} from './FilterBox-utils';

const FiltersHeader: FC<React.PropsWithChildren<FiltersHeaderProps>> = ({
  onResetFilters,
  numberOfFilters = 0,
  filterIssuesBy,
  splitFilterTypeName,
}) => {
  const { classes } = useStyles();
  return (
    <div className={classes.headerContainer}>
      <div className={classes.filtersNumberContainer}>
        <Typography
          variant='body2'
          color='text.primary'
          style={{ fontSize: '0.725rem' }}>
          Filter by:
        </Typography>
        {filterIssuesBy && numberOfFilters > 0 ? (
          <Tooltip
            arrow
            placement='right'
            title={
              <div className={classes.tooltipTitle}>
                <Typography
                  variant='body1'
                  color='text.primary'
                  fontWeight='bold'>
                  Filters Enabled
                </Typography>
                {Object.entries(filterIssuesBy).map((filterName, index) => {
                  const checkFilterType = isRangeFilter(filterName[0]);
                  return (
                    <Typography
                      variant='body2'
                      color='text.primary'
                      component='div'
                      key={index}>
                      <p className={classes.categoryTitle}>
                        {resolveFilterName(filterName[0])}
                      </p>
                      {checkFilterType
                        ? filterName[1].map((value: string, index: number) => {
                            return filterName[0] ===
                              FilterTypeToFilter.Category ? (
                              <p key={index}>{getCategoryById(value) + '\n'}</p>
                            ) : value.length > 30 ? (
                              <p key={index}>
                                {value.includes('/')
                                  ? splitFilterTypeName(value, 30) + '\n'
                                  : value.slice(0, 30) + '...\n'}
                              </p>
                            ) : (
                              <p key={index}>{value + '\n'}</p>
                            );
                          })
                        : filterName[0] ===
                            FilterTypeToFilter.BusinessPriority && (
                            <p>
                              From: {Object.values(filterName[1])[0]}
                              {'\n'}
                              To: {Object.values(filterName[1])[1]}
                            </p>
                          )}
                    </Typography>
                  );
                })}
              </div>
            }>
            <div className={classes.filtersNumber}>
              <Typography
                variant='subtitle2'
                mt={0.1}
                className={classes.filtersNumberContent}>
                {numberOfFilters}
              </Typography>
            </div>
          </Tooltip>
        ) : null}
      </div>
      <Button
        size='small'
        variant='text'
        style={{ textTransform: 'none', fontSize: '0.725rem' }}
        onClick={onResetFilters}
        disabled={numberOfFilters <= 0}>
        Clear all filters
      </Button>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filtersNumber: {
    width: 30,
    height: 17,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    borderRadius: 30,
    marginInlineStart: theme.spacing(1),
  },
  filtersNumberContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  filtersNumberContent: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
  },
  categoryTitle: {
    fontWeight: 'bold',
  },
  tooltipTitle: {
    margin: '2%',
  },
}));

export interface FiltersHeaderProps {
  onResetFilters?: () => void;
  numberOfFilters?: number;
  filterIssuesBy: { [key: string]: string[] };
  splitFilterTypeName: (name: string, width: number) => void;
}

export default FiltersHeader;
